export const loginStyles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: '0 16px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  card: { width: '100%', maxWidth: 400, boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' },
  header: { textAlign: 'center' as const, marginBottom: 24 },
  logo: { width: 80, height: 80, marginBottom: 16, borderRadius: 16 },
  title: { marginBottom: 8 },
  kakaoButton: {
    backgroundColor: '#FEE500',
    borderColor: '#FEE500',
    color: '#000000',
    fontWeight: 600 as const,
  },
  naverButton: {
    backgroundColor: '#03C75A',
    borderColor: '#03C75A',
    color: '#FFFFFF',
    fontWeight: 600 as const,
  },
  appleButton: {
    backgroundColor: '#000000',
    borderColor: '#000000',
    color: '#FFFFFF',
    fontWeight: 600 as const,
  },
}
